/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  VariablesMailTemplateResponseData,
  VariablesMailTemplateResponseDataFromJSON,
  VariablesMailTemplateResponseDataFromJSONTyped,
  VariablesMailTemplateResponseDataToJSON
} from './VariablesMailTemplateResponseData'

/**
 *
 * @export
 * @interface VariablesMailTemplateResponse
 */
export interface VariablesMailTemplateResponse {
  /**
   *
   * @type {number}
   * @memberof VariablesMailTemplateResponse
   */
  status?: number
  /**
   *
   * @type {VariablesMailTemplateResponseData}
   * @memberof VariablesMailTemplateResponse
   */
  data?: VariablesMailTemplateResponseData
}

export function VariablesMailTemplateResponseFromJSON(json: any): VariablesMailTemplateResponse {
  return VariablesMailTemplateResponseFromJSONTyped(json, false)
}

export function VariablesMailTemplateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): VariablesMailTemplateResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : VariablesMailTemplateResponseDataFromJSON(json['data'])
  }
}

export function VariablesMailTemplateResponseToJSON(value?: VariablesMailTemplateResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: VariablesMailTemplateResponseDataToJSON(value.data)
  }
}
